import React from 'react';
import { string } from 'prop-types';
import { Grid } from '@material-ui/core';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { NamedLink } from '../../components';
import imgDesktop from '../../assets/landing-page/banner.jpg';
import imgMobile from '../../assets/landing-page/banner.jpg';
import css from './SectionHero.css';

const SectionHero = props => {
  const { rootClassName, className, isAuthenticated, scrollHandler } = props;

  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <div className={css.banner}>
        <img 
          src={imgDesktop} 
          draggable="false" 
          loading='lazy' 
          className={css.imgHero} 
          alt="Wedding dresses promotion"
        />
        <div className={css.contentContainer}>
          <h1 className={css.heroMainTitle}>
          Vende, compra y descubre
          </h1>
          <p className={css.heroSubTitle}>
          vestidos, bolsas, ropa, zapatos y más
          </p>
          <div className={css.buttonContainer}>
            <NamedLink
              name="NewListingPage"
              className={css.heroButton}
            >
              Vender hoy →
            </NamedLink>
            <NamedLink
              name="SearchPage"
              to={{
                search: '?hotlist=true',
              }}
              className={css.heroButton}
            >
              Comprar ahora →
            </NamedLink>
          </div>
        </div>
      </div>
    </div>
  );
};

SectionHero.defaultProps = { rootClassName: null, className: null };

SectionHero.propTypes = {
  rootClassName: string,
  className: string,
};

export default SectionHero;
